import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";

const WishlistContext = createContext(null);
export const useWishlist = () => useContext(WishlistContext);

const KEY = "skg_wishlist";

export function WishlistProvider({ children }) {
  const { user } = useAuth();
  const [ids, setIds] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem(KEY)) || [];
    } catch {
      return [];
    }
  });

  useEffect(() => {
    localStorage.setItem(KEY, JSON.stringify(ids));
  }, [ids]);

  const syncFromServer = useCallback(async () => {
    if (!user) return;
    try {
      const { data } = await api.get("/wishlist");
      setIds(data.map((p) => p.id));
    } catch {}
  }, [user]);

  useEffect(() => {
    syncFromServer();
  }, [syncFromServer]);

  const has = (pid) => ids.includes(pid);

  const toggle = async (pid, name) => {
    const isIn = has(pid);
    setIds((prev) => (isIn ? prev.filter((x) => x !== pid) : [...prev, pid]));
    toast(isIn ? "Αφαιρέθηκε από τα αγαπημένα" : "Προστέθηκε στα αγαπημένα", { description: name });
    if (user) {
      try {
        if (isIn) await api.delete(`/wishlist/${pid}`);
        else await api.post(`/wishlist/${pid}`);
      } catch {}
    }
  };

  return (
    <WishlistContext.Provider value={{ ids, has, toggle, count: ids.length, syncFromServer }}>
      {children}
    </WishlistContext.Provider>
  );
}
